(function () {
  const newsletterForm = document.querySelector('[data-newsletter-form]');
  if (!newsletterForm) return;

  newsletterForm.addEventListener('submit', function (event) {
    event.preventDefault();
    const emailInput = newsletterForm.querySelector('input[type="email"]');
    if (!emailInput.value) {
      emailInput.classList.add('is-invalid');
      return;
    }

    emailInput.classList.remove('is-invalid');
    const alertPlaceholder = newsletterForm.querySelector('[data-newsletter-alert]');
    if (alertPlaceholder) {
      alertPlaceholder.innerHTML = '<div class="alert alert-success mb-0" role="alert">Thanks! We\'ll be in touch shortly.</div>';
    }
  });
})();

(function () {
  const freightSelect = document.querySelector('[data-freight-select]');
  if (!freightSelect) return;

  const showcaseRoot = document.querySelector('[data-product-showcase-root]');
  const costTarget = document.querySelector('[data-freight-cost]');
  const noteTarget = document.querySelector('[data-freight-note]');
  const descriptionTarget = document.querySelector('[data-freight-description]');
  const taxTarget = document.querySelector('[data-sales-tax-message]');
  const purchaseForm = document.querySelector('[data-purchase-form]');
  const purchaseAction = document.querySelector('[data-purchase-action]');
  const defaultNote = noteTarget ? noteTarget.textContent : '';
  const defaultDescription = descriptionTarget ? descriptionTarget.textContent : '';
  const estimateNote = 'Freight is an estimate that does not include lift gate service.';
  const quoteNote = 'Shipping quote required for this destination.';
  const quoteDescription = "Contact us for a shipping quote. Shipping costs are more variable to this state compared to others, but we're happy to provide you with an exact amount to ship to you.";
  const freightSource = freightSelect.dataset.freightSource || 'https://static-cdn.batterywholesale.com/fencemower/shipping_rates.csv';
  const freightStateCookieName = 'freight_state';
  const geodataCookieName = 'geodata';
  const cookieMaxAgeSeconds = 60 * 60 * 24 * 30;

  function getCookie(name) {
    const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setCookie(name, value, maxAgeSeconds) {
    document.cookie = `${name}=${encodeURIComponent(value)}; max-age=${maxAgeSeconds}; path=/; samesite=strict`;
  }

  function normalizeKey(value) {
    return value.trim().toLowerCase();
  }

  function findOptionByValue(value) {
    if (!value) return null;
    return Array.from(freightSelect.options).find((option) => option.value === value) || null;
  }

  function hasDestinationOption(value) {
    return Boolean(findOptionByValue(value));
  }

  function setFreightDestination(value) {
    if (!hasDestinationOption(value)) return false;
    freightSelect.value = value;
    updateFreightDetails();
    return true;
  }

  function getStoredFreightState() {
    const stored = getCookie(freightStateCookieName);
    return hasDestinationOption(stored) ? stored : null;
  }

  function storeFreightState(value) {
    if (!hasDestinationOption(value)) return;
    setCookie(freightStateCookieName, value, cookieMaxAgeSeconds);
  }

  function resolveGeoDestination(geoData) {
    if (!geoData) return null;
    if (geoData.country_code && geoData.country_code !== 'US') {
      return hasDestinationOption('International') ? 'International' : null;
    }
    if (hasDestinationOption(geoData.state)) {
      return geoData.state;
    }
    return null;
  }

  function formatCost(value) {
    const trimmed = value.trim();
    if (!trimmed) return '';
    return trimmed.startsWith('$') ? trimmed : `$${trimmed}`;
  }

  function parseCsvLine(line) {
    const values = [];
    let current = '';
    let inQuotes = false;

    for (let i = 0; i < line.length; i += 1) {
      const char = line[i];
      if (char === '"') {
        if (inQuotes && line[i + 1] === '"') {
          current += '"';
          i += 1;
        } else {
          inQuotes = !inQuotes;
        }
        continue;
      }
      if (char === ',' && !inQuotes) {
        values.push(current);
        current = '';
        continue;
      }
      current += char;
    }
    values.push(current);
    return values.map((value) => value.trim());
  }

  function getFreightSelectionState() {
    const option = freightSelect.options[freightSelect.selectedIndex];
    if (!option || !option.value) {
      return {
        mode: 'none',
        destination: '',
        cost: '',
        note: '',
      };
    }

    const cost = option.dataset.cost || '';
    const isQuote = option.dataset.quote === 'true' || !cost;
    return {
      mode: isQuote ? 'quote' : 'priced',
      destination: option.value,
      cost,
      note: option.dataset.note || '',
    };
  }

  function updateSalesTaxMessage(selectionState) {
    if (!taxTarget) return;
    if (!selectionState.destination) {
      taxTarget.textContent = 'Sales tax: select destination first.';
      return;
    }

    if (selectionState.destination === 'Texas') {
      taxTarget.textContent = 'If you hold a valid tax exemption, sales tax will not be collected.';
      return;
    }

    taxTarget.textContent = `If you have a valid tax exemption, sales tax will not be collected during checkout.`;
  }

  function updatePurchaseAction(selectionState) {
    if (!purchaseAction) return;
    const hasSelectedProduct = Boolean(showcaseRoot && showcaseRoot.dataset.selectedVariantId);

    if (!hasSelectedProduct) {
      purchaseAction.textContent = 'Choose mower first';
      purchaseAction.dataset.actionMode = 'disabled';
      purchaseAction.disabled = true;
      return;
    }

    if (selectionState.mode === 'none') {
      purchaseAction.textContent = 'Select destination first';
      purchaseAction.dataset.actionMode = 'disabled';
      purchaseAction.disabled = true;
      return;
    }

    if (selectionState.mode === 'priced') {
      purchaseAction.textContent = 'Add to Cart';
      purchaseAction.dataset.actionMode = 'cart';
      purchaseAction.disabled = false;
      return;
    }

    purchaseAction.textContent = 'Request a Shipping Quote';
    purchaseAction.dataset.actionMode = 'quote';
    purchaseAction.disabled = false;
  }

  function updateFreightDetails() {
    const selectionState = getFreightSelectionState();
    const hasDestination = Boolean(selectionState.destination);
    const isQuoteSelected = selectionState.mode === 'quote';
    const resolvedNote = hasDestination
      ? (isQuoteSelected ? quoteNote : estimateNote)
      : defaultNote;
    const resolvedDescription = hasDestination
      ? (isQuoteSelected ? quoteDescription : '')
      : defaultDescription;
    const freightLabel = document.querySelector('[data-freight-label]');
    if (freightLabel) {
      freightLabel.classList.toggle('d-none', !hasDestination);
    }
    if (costTarget) {
      if (isQuoteSelected) {
        costTarget.textContent = 'Shipping quote required';
      } else {
        costTarget.textContent = selectionState.cost;
      }
    }
    if (noteTarget) noteTarget.textContent = resolvedNote;
    if (descriptionTarget) {
      descriptionTarget.textContent = resolvedDescription;
      descriptionTarget.classList.toggle('d-none', !resolvedDescription);
    }
    updateSalesTaxMessage(selectionState);
    updatePurchaseAction(selectionState);
  }

  function applyFreightRates(ratesByState) {
    Array.from(freightSelect.options).forEach((option) => {
      if (!option.value) return;
      const rate = ratesByState.get(normalizeKey(option.value));
      if (!rate) return;
      if (rate.cost) option.dataset.cost = rate.cost;
      if (rate.note) option.dataset.note = rate.note;
      if (rate.isQuote) option.dataset.quote = 'true';
    });
  }

  function buildFreightRateMap(csvText) {
    const ratesByState = new Map();
    const rows = csvText.split(/\r?\n/).map((line) => line.trim()).filter(Boolean);
    rows.forEach((row, index) => {
      const columns = parseCsvLine(row);
      if (!columns.length) return;
      if (index === 0) {
        const header = normalizeKey(columns.join(' '));
        if (header.includes('state') || header.includes('province') || header.includes('destination')) {
          return;
        }
      }
      const state = columns[1] || '';
      const rawCost = columns[2] || '';
      const note = columns[3] || '';
      if (!state.trim()) return;
      const isQuote = rawCost.trim().toLowerCase() === 'get quote';
      const formattedCost = isQuote ? '' : formatCost(rawCost);
      ratesByState.set(normalizeKey(state), {
        cost: formattedCost,
        note: note.trim(),
        isQuote
      });
    });
    return ratesByState;
  }

  function loadFreightRates() {
    return fetch(freightSource)
      .then((response) => {
        if (!response.ok) throw new Error(`Freight rate request failed: ${response.status}`);
        return response.text();
      })
      .then((csvText) => {
        const ratesByState = buildFreightRateMap(csvText);
        applyFreightRates(ratesByState);
        updateFreightDetails();
      })
      .catch(() => {
        Array.from(freightSelect.options).forEach((option) => {
          if (!option.value) return;
          delete option.dataset.cost;
          option.dataset.quote = 'true';
          option.dataset.note = 'Shipping rates are unavailable online right now. Request a shipping quote and we will follow up.';
        });
        updateFreightDetails();
      });
  }

  function showOutsideUsMessage() {
    setFreightDestination('International');
  }

  async function getGeolocation() {
    const cached = getCookie(geodataCookieName);
    if (cached) {
      try {
        return JSON.parse(cached);
      } catch (error) {
        // Ignore invalid cache entries and fall through to live lookup.
      }
    }

    try {
      const response = await fetch('https://geolocation-db.com/json/');
      if (response.ok) {
        const geoData = await response.json();
        setCookie(geodataCookieName, JSON.stringify(geoData), cookieMaxAgeSeconds);
        return geoData;
      }
    } catch (error) {
      // Fall through to secondary provider.
    }

    try {
      const response = await fetch('https://ipapi.co/json/');
      if (!response.ok) return null;
      const geoData = await response.json();
      geoData.state = geoData.region;
      setCookie(geodataCookieName, JSON.stringify(geoData), cookieMaxAgeSeconds);
      return geoData;
    } catch (error) {
      return null;
    }
  }

  const quoteModalElement = document.querySelector('[data-freight-quote-modal]');
  const quoteModal = quoteModalElement && window.bootstrap ? new window.bootstrap.Modal(quoteModalElement) : null;
  const quoteStateSelect = quoteModalElement ? quoteModalElement.querySelector('[data-freight-quote-state]') : null;
  const quoteZipGroup = quoteModalElement ? quoteModalElement.querySelector('[data-freight-zip-group]') : null;
  const quoteZipInput = quoteModalElement ? quoteModalElement.querySelector('[data-freight-zip]') : null;
  const quoteProductInput = quoteModalElement ? quoteModalElement.querySelector('[data-freight-quote-product]') : null;
  const quoteSubjectInput = quoteModalElement ? quoteModalElement.querySelector('[data-freight-quote-subject]') : null;
  const quoteProductLabel = quoteModalElement ? quoteModalElement.querySelector('[data-freight-quote-product-label]') : null;

  function updateZipVisibility() {
    if (!quoteZipGroup || !quoteZipInput || !quoteStateSelect) return;
    const hasState = Boolean(quoteStateSelect.value);
    quoteZipGroup.classList.toggle('d-none', !hasState);
    quoteZipInput.required = hasState;
    if (!hasState) quoteZipInput.value = '';
  }

  function syncQuoteContext() {
    if (quoteStateSelect) {
      quoteStateSelect.value = freightSelect.value || '';
    }
    if (quoteProductInput && showcaseRoot) {
      quoteProductInput.value = showcaseRoot.dataset.selectedProductTitle || quoteProductInput.value || '';
    }
    if (quoteSubjectInput && showcaseRoot) {
      quoteSubjectInput.value = `Shipping quote request - ${showcaseRoot.dataset.selectedProductTitle || ''}`;
    }
    if (quoteProductLabel && showcaseRoot) {
      quoteProductLabel.textContent = showcaseRoot.dataset.selectedProductTitle || '';
    }
    updateZipVisibility();
  }

  freightSelect.addEventListener('change', function () {
    updateFreightDetails();
    if (freightSelect.value) {
      storeFreightState(freightSelect.value);
    }
  });
  document.addEventListener('product-showcase-selection-changed', function () {
    updateFreightDetails();
  });
  if (quoteStateSelect) {
    quoteStateSelect.addEventListener('change', updateZipVisibility);
  }
  if (purchaseForm) {
    purchaseForm.addEventListener('submit', function (event) {
      if (!purchaseAction) return;
      const actionMode = purchaseAction.dataset.actionMode || 'disabled';
      if (actionMode === 'cart') return;

      event.preventDefault();
      if (actionMode !== 'quote' || !quoteModalElement || !quoteModal) return;
      syncQuoteContext();
      quoteModal.show();
    });
  }
  if (quoteModalElement) {
    quoteModalElement.addEventListener('shown.bs.modal', function () {
      const emailInput = quoteModalElement.querySelector('input[type="email"]');
      if (emailInput) emailInput.focus();
    });
    if (quoteModal && quoteModalElement.querySelector('.alert')) {
      quoteModal.show();
    }
  }
  updateFreightDetails();
  updateZipVisibility();
  const storedFreightState = getStoredFreightState();
  if (storedFreightState) {
    setFreightDestination(storedFreightState);
  }
  loadFreightRates();
  getGeolocation().then((geoData) => {
    if (getStoredFreightState()) return;

    const resolvedDestination = resolveGeoDestination(geoData);
    if (!resolvedDestination) return;

    if (resolvedDestination === 'International') {
      showOutsideUsMessage();
    } else {
      setFreightDestination(resolvedDestination);
    }
    storeFreightState(resolvedDestination);
  });
})();

(function () {
  const modals = document.querySelectorAll('.modal');
  if (!modals.length) return;

  modals.forEach((modal) => {
    modal.addEventListener('hide.bs.modal', () => {
      const iframe = modal.querySelector('iframe');
      if (!iframe) return;
      if (!iframe.dataset.src) {
        iframe.dataset.src = iframe.src;
      }
      iframe.src = '';
    });

    modal.addEventListener('show.bs.modal', () => {
      const iframe = modal.querySelector('iframe');
      if (!iframe || !iframe.dataset.src) return;
      iframe.src = iframe.dataset.src;
    });
  });
})();


$(document).ready(function () {
  var slider = $('#yt-slider');
  if (!slider.length) return;
  if (slider.hasClass('slick-initialized')) return;

  // Initialize Slick
  slider.slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    arrows: false, // Disable default arrows
    dots: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  $('.video-swiper-button-next').on('click', function () {
    slider.slick('slickNext');
  });
  // Custom button controls
  $('.video-swiper-button-prev').on('click', function () {
    slider.slick('slickPrev');
  });

  $(window).on('load resize orientationchange', function () {
    if (slider.hasClass('slick-initialized')) {
      slider.slick('setPosition');
    }
  });


});

$(document).ready(function () {
  var slider = $('#review-slider');
  if (!slider.length) return;
  if (slider.hasClass('slick-initialized')) return;

  // Initialize Slick
  slider.slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    arrows: false, // Disable default arrows
    dots: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  $('.review-swiper-button-next').on('click', function () {
    slider.slick('slickNext');
  });
  // Custom button controls
  $('.review-swiper-button-prev').on('click', function () {
    slider.slick('slickPrev');
  });

  $(window).on('load resize orientationchange', function () {
    if (slider.hasClass('slick-initialized')) {
      slider.slick('setPosition');
    }
  });


});

// Mobile meu on scroll change bachground color
window.addEventListener('scroll', () => {
  const header = document.getElementById('mobile-menu');

  if (window.scrollY > 10) {
    header.classList.add('scrolled');
  } else {
    header.classList.remove('scrolled');
  }
});
